import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './BlogDetails.css';

const BlogDetails = () => {
  const location = useLocation();
  const { blog } = location.state || {};
  const { title } = useParams();

  if (!blog) {
    return (
      <div className="blog-details">
        <div className="overlay"></div>
        <div className="blog-details-content">
          <h2>{decodeURIComponent(title)}</h2>
          <p style={{ textAlign: 'center' }}>Loading blog content...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="blog-details"
      style={{ backgroundImage: `url(${blog.image})` }}
    >
      <div className="overlay"></div>
      <div className="blog-details-content">
        <h2>{blog.title}</h2>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h2: ({node, ...props}) => <h2 style={{marginTop: '20px'}} {...props} />,
            h3: ({node, ...props}) => <h3 style={{marginTop: '15px'}} {...props} />,
            li: ({node, ...props}) => <li style={{marginBottom: '5px'}} {...props} />
          }}
        >
          {blog.fullContent}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default BlogDetails;
